(function() {
  if (!window.location.pathname.includes('/pages/loyalty')) return;

  let reinitTimer = null;

  function reinitModals() {
    if (!window.RivoAlpine) return;
    document.querySelectorAll('.rivo-modal').forEach(modal => {
      window.RivoAlpine.mutateDom(() => {
        window.RivoAlpine.initTree(modal);
      });
    });
  }

  function watchButtonStateChanges() {
    const btnObserver = new MutationObserver((mutations) => {
      mutations.forEach(m => {
        if (m.type === 'attributes' && 
            m.attributeName === 'rivo-x-on:click.prevent' &&
            m.target.getAttribute('rivo-x-on:click.prevent') === 'window.applyPointsPurchaseDiscount') {
          
          const btn = m.target;
          clearTimeout(reinitTimer);

          const savedText = btn.textContent.trim();
          btn.removeAttribute('rivo-x-text');
          
          reinitModals();
          
          setTimeout(() => {
            btn.textContent = savedText;
          }, 50);
        }
      });
    });

    btnObserver.observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ['rivo-x-on:click.prevent']
    });
  }

  function patch() {
    const original = window.renderRewardModal;
    if (!original || original._patched) return;
    
    window.renderRewardModal = function(...args) {
      const result = original.apply(this, args);
      reinitTimer = setTimeout(reinitModals, 0);
      return result;
    };
    window.renderRewardModal._patched = true;
  }

  document.addEventListener('DOMContentLoaded', () => { patch(); watchButtonStateChanges(); });
  window.addEventListener('load', () => { patch(); watchButtonStateChanges(); });
  
  let _lastFn = null;
  const interval = setInterval(() => {
    if (window.renderRewardModal && 
        window.renderRewardModal !== _lastFn && 
        !window.renderRewardModal._patched) {
      patch();
    }
    _lastFn = window.renderRewardModal;
  }, 500);
})();